/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForWorkloadOntologyMigration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForWorkloadOntologyMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForWorkloadOntologyMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForWorkloadOntologyMigration>): BackgroundJobPayloadForWorkloadOntologyMigration {
        let obj = Object.assign(new BackgroundJobPayloadForWorkloadOntologyMigration(), model);
        BackgroundJobPayloadForWorkloadOntologyMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForWorkloadOntologyMigration>): BackgroundJobPayloadForWorkloadOntologyMigration {
        if (!model) return null;
        return BackgroundJobPayloadForWorkloadOntologyMigration.newInstance(<BackgroundJobPayloadForWorkloadOntologyMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForWorkloadOntologyMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForWorkloadOntologyMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForWorkloadOntologyMigration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForWorkloadOntologyMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
